<div class="submit-proposal-right">
  @if (step() === SubmitProposalStep.Choice && !planAllowsChangeExamComponent()) {
    <span>{{ 'submitProposal.selectionText' | translate }}</span>
  } @else {
    <span>{{ 'submitProposal.selectedText' | translate }}</span>
  }

  @if (submitWholeProgram()) {
    <pa-add-course-list-header [title]="submitInfo()!.electives.examComponentName" class="course-list-header__level1" />
  }

  @if (showFilteredElectivesCourses()) {
    @for (selectedElectivesCourseGroup of selectedElectivesCourseGroups(); track selectedElectivesCourseGroup.title) {
      @if (selectedElectivesCourseGroup.courseDataList.length) {
        <pa-add-course-list-header
          [title]="selectedElectivesCourseGroup.title"
          [ngClass]="{ 'course-list-header__level2': submitWholeProgram() }"
        />

        @for (electivesCourseData of selectedElectivesCourseGroup.courseDataList; track electivesCourseData.uniqueId) {
          <pa-add-course-list-item [showCheckbox]="false" [selected]="true" [selectable]="false" [disabled]="true">
            <pa-course-item [courseData]="electivesCourseData" showCategory hideShowInfo hideTimeslots />
          </pa-add-course-list-item>
        }
      }
    }
  } @else {
    @for (electivesGroup of electivesCourseGroups(); track electivesGroup.title) {
      @if (electivesGroup.submitCourseItems.length) {
        <pa-add-course-list-header
          [title]="electivesGroup.title"
          [subTitle]="getSubtitle(electivesGroup)"
          [ngClass]="{ 'course-list-header__level2': submitWholeProgram() }"
        />

        @for (electivesCourseItem of electivesGroup.submitCourseItems; track electivesCourseItem.courseData.uniqueId) {
          <pa-add-course-list-item
            [showCheckbox]="!planAllowsChangeExamComponent()"
            [selected]="electivesCourseItem.selected"
            [selectable]="isCourseSelectable(electivesCourseItem)"
            [disabled]="electivesCourseItem.disabled"
            (selectCourse)="onSelectCourse(electivesCourseItem, $event)"
          >
            <pa-course-item [courseData]="electivesCourseItem.courseData" showCategory hideShowInfo hideTimeslots />
          </pa-add-course-list-item>
        }
      }
    }
  }

  @for (otherGroup of otherCourseGroups(); track otherGroup.title) {
    @if (otherGroup.submitCourseItems.length) {
      <pa-add-course-list-header [title]="otherGroup.title" class="course-list-header__level1" />

      @for (otherCourseItem of otherGroup.submitCourseItems; track $index) {
        <pa-add-course-list-item [showCheckbox]="false" [selected]="true" [selectable]="false" [disabled]="true">
          <pa-course-item [courseData]="otherCourseItem.courseData" hideShowInfo hideTimeslots />
        </pa-add-course-list-item>
      }
    }
  }
</div>
